import { useEffect } from 'react'
import { useToast } from './Toast'

// Listens for core write failures dispatched by useWatchlist (nextep:save-failed)
// and shows a single debounced toast, so a failed save is never silent. Debounced
// because a bulk operation can emit many failures at once.
export function SaveErrorToast() {
  const toast = useToast()
  useEffect(() => {
    let last = 0
    const handler = (e) => {
      const now = Date.now()
      if (now - last < 1500) return
      last = now
      const action = e.detail?.action || 'change'
      toast.show(`Couldn't save your ${action}, check your connection`, { tone: 'danger', duration: 3200 })
    }
    // A write that failed only because the network is gone is kept in the outbox and
    // replayed later; say so in a calm voice instead of the red "check your connection".
    let lastQueued = 0
    const queued = () => {
      const now = Date.now()
      if (now - lastQueued < 4000) return
      lastQueued = now
      toast.show('Saved on this phone. It syncs when you’re back online.', { tone: 'default', duration: 3200 })
    }
    const synced = (e) => {
      const n = e.detail?.count || 0
      if (n) toast.show(n === 1 ? 'Back online, your change is saved.' : `Back online, ${n} changes saved.`, { tone: 'default', duration: 2600 })
    }
    window.addEventListener('nextep:save-failed', handler)
    window.addEventListener('nextep:save-queued', queued)
    window.addEventListener('nextep:outbox-synced', synced)
    return () => {
      window.removeEventListener('nextep:save-failed', handler)
      window.removeEventListener('nextep:save-queued', queued)
      window.removeEventListener('nextep:outbox-synced', synced)
    }
  }, [toast])
  return null
}
